module.exports = __webpack_public_path__ + "img/電気回路_6_6_5.7c72a0f1.png";